<template>
  <div>
    <v-data-table
      :headers="tempStockDataTableHeaders"
      :items="tempStockList"
      class="elevation-1"
      :loading="isLoadingTempStock"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :server-items-length="totalRows"
      :options="currentOptions"
      @update:options="updateOptions"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>庫存表</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- 隱藏的 file input，限制只能選 .xlsx -->
          <input
            type="file"
            ref="file"
            accept=".xlsx"
            style="display: none"
            v-if="!isLoadingTempStock"
            @change="uploadTempStock"
          />
          <v-btn color="primary" :disabled="isImportDisabled" @click="openFileDialog">
            匯入庫存
          </v-btn>
        </v-toolbar>
        <!-- 醒目備註：匯入規則提醒 -->
        <v-alert type="info" dense outlined prominent class="mx-4 mt-2">
          <div><strong>匯入須知：</strong></div>
          <div>1. 每日下午 <strong>5:00 後</strong>才可執行匯入（Admin 不受此限制）</div>
          <div>2. 檔案格式限 <strong>.xlsx</strong></div>
          <div>3. 檔案名稱必須為 <strong>「CRM庫存表.xlsx」</strong></div>
          <div style="color: red; font-size: 2em; font-weight: bold;">{{ $t('temp_stock_latest_import_time') }}{{ convertToDateTimeFormat(newUpdateTime) }}</div>
        </v-alert>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { HttpTempStock } from '@/js/http-Manager'
import { mapGetters } from 'vuex'

export default {
  name: 'TempStock',
  data: () => ({
    tempStockList: [],
    isLoadingTempStock: true,
    totalRows: 0,
    isUpdateEventTotal: true,
    currentOptions: {
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      triggerByOutsite: true
    },
    newUpdateTime: 0
  }),
  async mounted () {
    await this.getTotalCount()
    await this.getTempStock()
  },
  computed: {
    ...mapGetters('login', {
      isRoleAdmin: 'isRoleAdmin'
    }),
    // 判斷目前時間是否已過下午 5 點
    isAfter5PM () {
      return new Date().getHours() >= 17
    },
    // 匯入按鈕停用條件：載入中 或（非 Admin 且尚未到下午 5 點）
    isImportDisabled () {
      return this.isLoadingTempStock || (!this.isRoleAdmin && !this.isAfter5PM)
    },
    tempStockDataTableHeaders () {
      return [
        {
          text: '品號',
          align: 'start',
          value: 'ItemNumber'
        },
        { text: '品名', align: 'start', value: 'ItemName' },
        { text: '庫別', align: 'start', value: 'ItemStock' },
        { text: '原始數量', align: 'start', value: 'OriginalQuantity' },
        { text: '今日使用數量', align: 'start', value: 'TodayUseStock' },
        { text: '目前數量', align: 'start', value: 'CurrentQuantity' }
      ]
    }
  },
  methods: {
    async getLatestUpdateTime () {
      let response = await HttpTempStock.GetLatestUpdateTime()
      this.newUpdateTime = response.status === 200 ? response.data.Data : 0
    },
    async getTotalCount () {
      if (this.isUpdateEventTotal) {
        let param = {
          name: this.searchCustomer
        }
        let response = await HttpTempStock.GetTempStockForDataTableCount(param)
        this.totalRows = response.status === 200 ? response.data.Data : 0
      }
    },
    updateOptions (val) {
      this.currentOptions = val
      this.isUpdateEventTotal = false
      this.getTempStock(val)
    },
    async getTempStock (val) {
      if (this.isUpdateEventTotal) {
        this.currentOptions.page = 1
        this.getTotalCount()
      }
      this.isUpdateEventTotal = true
      this.isLoadingTempStock = true
      let param = {
        PerPage:
          typeof val === 'object' && val ? val.itemsPerPage : this.currentOptions.itemsPerPage,
        Page: typeof val === 'object' && val ? val.page : this.currentOptions.page,
        SortBy: typeof val === 'object' && val ? val.sortBy[0] : this.currentOptions.sortBy[0],
        SortDesc: typeof val === 'object' && val ? val.sortDesc[0] : this.currentOptions.sortBy[0]
      }
      let response = await HttpTempStock.GetTempStockForDataTable(param)
      this.isLoadingTempStock = false
      this.tempStockList = response && response.status === 200 ? response.data.Data : []
      await this.getLatestUpdateTime()
    },
    openFileDialog () {
      this.$refs.file.click()
    },
    async uploadTempStock (event) {
      if (event.target.files.length > 0) {
        const file = event.target.files[0]

        // 再次檢查是否已過下午 5 點（防止繞過），Admin 不受限
        if (!this.isRoleAdmin && new Date().getHours() < 17) {
          alert('尚未到下午 5:00，無法匯入庫存。')
          this.$refs.file.value = ''
          return
        }

        // 驗證副檔名必須是 .xlsx
        if (!file.name.endsWith('.xlsx')) {
          alert('檔案格式錯誤，僅接受 .xlsx 檔案。')
          this.$refs.file.value = ''
          return
        }

        // 驗證檔名必須是 CRM庫存表.xlsx
        if (file.name !== 'CRM庫存表.xlsx') {
          alert('檔案名稱必須為「CRM庫存表.xlsx」，請重新選擇。')
          this.$refs.file.value = ''
          return
        }

        this.isLoadingTempStock = true
        let formData = new FormData()
        formData.append('file', file)
        await HttpTempStock.ImportTempStock(formData)
        await this.getTotalCount()
        await this.getTempStock()
        this.isLoadingTempStock = false
        // 重置 file input 以便下次可重新選擇相同檔案
        this.$refs.file.value = ''
      }
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    }
  }
}
</script>
